export interface ProductionProcessesForSupplier {
  productionProcessId: string;
  productionProcessDescription: string;
  default: boolean;
  selected: boolean;
}
